import { useEffect, useState } from "react";
import axios from "axios";
import { APIURL, AUTH_CREDENTIALS_NAME } from "../Constantes";

const getCabecera = () => {
    let Token = localStorage.getItem(AUTH_CREDENTIALS_NAME);
    let cabecera = {
        Authorization: `bearer ${Token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
    }
    return cabecera;
}

export const useActivo = () => {
    const [activo, setActivo] = useState(true);
    useEffect(() => {
        const getIsActivo = async () => {
            return await axios.get(`${APIURL}/User/SesionActiva`,
                {
                    headers: getCabecera()
                }).then(Response => {
                    setActivo(Response.data)
                }).catch(Error => {
                    setActivo(false)
                })
        }
        getIsActivo();
        return () => {
            setActivo(true)
        }
    }, [])
    return [activo];
}